import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { GET_INMUEBLE_ID } from "../../../api/apiInmuebles";
import { PropagateLoader } from "react-spinners";
import CardHeader from "../../atoms/CardHeader";
import Heading from "../../atoms/Heading";
import InmuebleAccesosDirectos from "../../organisms/inmueble/inmuebleDocsTables/InmuebleAccesosDirectos";
import Breadcrumb from "../../molecules/Breadcrumb";

const InmuebleUserTemplate = () => {
    const { im } = useParams();
    const [loading, setLoading] = useState(true);
    const [inmueble, setInmueble] = useState();

    useEffect(() => {
        const getInmueble = async () => {
            try {
                const inmuebleData = await GET_INMUEBLE_ID(Number(im));
                setInmueble(inmuebleData);
            } catch (error) {
                console.error(error);
            } finally {
                setLoading(false);
            }
        };

        getInmueble();
    },[im]);

    if (loading) return <div className="w-full h-screen flex items-center justify-center"> <PropagateLoader color="red"/> </div>;

    return (
        <div className="flex flex-col gap-4">
            {inmueble ?
                    <>
                        <CardHeader
                          left={
                            <Breadcrumb
                              items={[
                                { label: "Inicio", to: "/inicio" },
                                { label: inmueble?.name, to: null },
                              ]}
                            />
                          }
                        />
                        <InmuebleAccesosDirectos inmueble={inmueble} />
                    </>
                :
                    <Heading text="Error al obtener el inmueble intente mas tarde y/o contacte con soporte tecnico" />
            }
        </div>
    );
};

export default InmuebleUserTemplate;